<!--<ion-header class="page-header ion-no-border">-->
<!--  <ion-toolbar mode="ios">-->
<!--    <ion-buttons slot="start" class="back">-->
<!--      <ion-back-button text="" icon="chevron-back-outline" defaultHref="/main"></ion-back-button>-->
<!--    </ion-buttons>-->
<!--    <app-page-title [title]="title" [subtitle]="subtitle"></app-page-title>-->
<!--  </ion-toolbar>-->
<!--</ion-header>-->
<app-page-wrapper
  [useHeader]="true"
  [useBackBtn]="true"
  [useFooter]="true"
  [title]="title"
>

  <ion-content>
    <div class="step-online-credit" *ngIf="loaded$ | async">
      <div class="esia">
        <div class="gosuslugi__logo ion-margin-top"></div>

        <div class="d-flex note note-primary ion-margin-top">
          Для получения кредита и совершения всех
          необходимых проверок на стороне Банка
          необходимо иметь подтвержденную учетную запись на Госуслугах.
        </div>

        <div class="new-online-credit-note note note-warning note-strong ion-margin-top">
          Для подтверждения получения данных
          о состоянии индивидуального лицевого счета
          Вам необходимо ответить на смс,
          полученное с короткого номера
          <span style="text-decoration: underline;font-weight: bolder;">0919</span>
        </div>
      </div>
    </div>
  </ion-content>

  <ng-container footer *ngIf="loaded$ | async">
    <ion-button expand="block" ripple-effect class="button block primary-light"
                [disabled]="isDisabled" (click)="registerAccount()">Зарегистрироваться
    </ion-button>
    <ion-button expand="block" ripple-effect class="button block primary"
                [disabled]="isDisabled" (click)="confirmAccount()">Подтвердить
    </ion-button>
    <ion-button expand="block"
                class="button primary-light"
                ripple-effect
                (click)="abort()"
    >
      Отмена
    </ion-button>
  </ng-container>


</app-page-wrapper>
<!-- </app-page> -->
